import { ThreeDotMenuItem } from "components/ThreeDotMenu";

export const menuItems = (
  published: boolean,
  deleteReview: () => void,
  onPublishUnpublishClicked: () => void
): ThreeDotMenuItem[] => [
  {
    label: published ? "Unpublish" : "Publish",
    onClick: onPublishUnpublishClicked,
  },
  {
    label: "Delete",
    onClick: deleteReview,
    className: "text-red-500",
  },
];
